const NORMALIZED_ID = ':id';

export function normalizeApiUrl(input: string): string {
  try {
    const path = input.replace(/^https?:\/\/[^/]+/, '');

    const segments = path.split('/').filter(Boolean);

    const normalized = segments.map((segment) => {
      const isUuid =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(segment);
      const isNumericId = /^\d+$/.test(segment);
      return isUuid || isNumericId ? NORMALIZED_ID : segment;
    });

    return '/' + normalized.join('/');
  } catch (error) {
    console.error('Cannot normalize api url:', error);
    return input;
  }
}
